export const menuData = [
  {
    id: 1,
    text: "FIND A LAWYER",
    link: "/contact",
    submenu: null,
    // subMenu: [
    //   {
    //     id: 11,
    //     text: "Personal / Family",
    //     link: null,
    //     tertiaryMenu: [
    //       { text: "Divorce", link: "/divorce" },
    //       { text: "Family Dispute", link: "/family-dispute" },
    //       { text: "Child Custody", link: "/child-custody" },
    //       { text: "Muslim Law", link: "/muslim-law" },
    //       { text: "Medical Negligence", link: "/medical-negligence" },
    //       { text: "Motor Accident", link: "/motor-accident" },
    //       { text: "Wills/Trusts", link: "/wills-trusts" },
    //       { text: "Labour & Service", link: "/labour-service" },
    //     ],
    //   },
    //   {
    //     id: 12,
    //     text: "Corporate Law",
    //     link: null,
    //   },
    //   {
    //     id: 13,
    //     text: "Civil / Debt Matters",
    //     link: null,
    //   },
    //   {
    //     id: 14,
    //     text: "Criminal / Property",
    //     link: null,
    //   },
    //   {
    //     id: 15,
    //     text: "Others",
    //     link: null,
    //   },
    // ],
  },
  {
    id: 2,
    text: "LEGAL ADVICE",
    link: null,
    subMenu: [
      {
        id: 21,
        text: "Indian Penal Code (IPC)",
        link: "/legal-advice/ipc",
      },
      {
        id: 22,
        text: "Code of Criminal Procedure (CrPC)",
        link: "/legal-advice/crpc",
      },
      {
        id: 23,
        text: "Code Of Civil Procedure (CPC)",
        link: "/legal-advice/cpc",
      },
      {
        id: 24,
        text: "Income Tax Act",
        link: "/legal-advice/it-act",
      },
    ],
  },
  {
    id: 3,
    text: "EDITORIALS",
    link: "/blog",
    subMenu: null,
  },
  {
    id: 4,
    text: "ABOUT",
    link: "/about-us",
    subMenu: null,
  },
  {
    id: 5,
    text: "CONTACT",
    link: "/contact",
    subMenu: null,
  },
];
